import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TtyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tty"}/>
}
